// React's view of the page-scoped call manager (one external store, no context needed: the call
// outlives every screen, like Apple's app-scope CallManager).
import { useSyncExternalStore } from 'react';
import type { ActiveCall } from '../../../core/activeCalls';
import type { CallsView } from '../../../data/features/calls';
import { callManager, type CallUiState } from './callManager';

export function useCallState(): CallUiState {
  return useSyncExternalStore(callManager.subscribe, callManager.getState);
}

export function useActiveCalls(): CallsView {
  return useSyncExternalStore(callManager.subscribeActive, callManager.getActive);
}

export function useActiveCall(channelId: string | null): ActiveCall | null {
  const view = useActiveCalls();
  return channelId ? view.calls.find((c) => c.channelId === channelId) ?? null : null;
}
